import { render } from "./VideoGalleryForm.vue?vue&type=template&id=68a79980&scoped=true"
import script from "./VideoGalleryForm.vue?vue&type=script&lang=js"
export * from "./VideoGalleryForm.vue?vue&type=script&lang=js"

import "./VideoGalleryForm.vue?vue&type=style&index=0&id=68a79980&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a79980"]])

export default __exports__